import React from "react";

function EmptyIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="62"
            height="62"
            fill="none"
            viewBox="0 0 62 62"
        >
            <g clipPath="url(#clip0_186_18597)">
                <g
                    stroke="#979AA3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    clipPath="url(#clip1_186_18597)"
                >
                    <path d="M36.5 16.667h-8c-.736 0-1.333.597-1.333 1.333v2.667c0 .736.597 1.333 1.333 1.333h8c.736 0 1.333-.597 1.333-1.333V18c0-.736-.597-1.333-1.333-1.333z"></path>
                    <path d="M27.167 19.333H24.5A2.667 2.667 0 0021.833 22v18.667a2.667 2.667 0 002.667 2.666h16a2.667 2.667 0 002.667-2.666V40M37.833 19.333H40.5a2.666 2.666 0 012.307 1.334M27.167 38H28.5"></path>
                    <path d="M41.033 26.8a2.828 2.828 0 014 4l-5.866 5.867L33.833 38l1.334-5.333 5.866-5.867z"></path>
                </g>
            </g>
            <path
                stroke="#979AA3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 61l6.333-18.998a28.33 28.33 0 1112.665 12.665L1 61z"
            ></path>
            <defs>
                <clipPath id="clip0_186_18597">
                    <path
                        fill="#fff"
                        d="M0 0H30V30H0z"
                        transform="translate(17.5 14.5)"
                    ></path>
                </clipPath>
                <clipPath id="clip1_186_18597">
                    <path
                        fill="#fff"
                        d="M0 0H32V32H0z"
                        transform="translate(16.5 14)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default EmptyIcon;
